// extracted by mini-css-extract-plugin
export var cardLayout = "_6w-1";
export var paginationContainer = "_6w-0";